import Validators from '../validators'
import Moment from 'moment'
import { extendMoment } from 'moment-range'
const moment = extendMoment(Moment)

export default (store) => store.createEmbededEntityState({
  attrs: ['from', 'to'],
  initVals: (row) => ({ id: null }),
  validators: {
    from: [
      Validators.isMandatory(store),
      Validators.positiveInt(store)
    ],
    to: [
      Validators.isMandatory(store),
      Validators.positiveInt(store)
    ],
    _global: vals => {
      if (vals.get('from') && vals.get('to') && parseInt(vals.get('from')) > parseInt(vals.get('to'))) {
        return ['"From" must be smaller than "to".']
      }
    }
  }
})
